import { render, staticRenderFns } from "./ConfirmButtons.vue?vue&type=template&id=2ed260f4&scoped=true&"
import script from "./ConfirmButtons.vue?vue&type=script&lang=ts&"
export * from "./ConfirmButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmButtons.vue?vue&type=style&index=0&id=2ed260f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed260f4",
  null
  
)

export default component.exports